import { Accounts } from '@or-sdk/accounts';

import { useAuthStore } from '@/stores/auth/auth';
import { sdkApiUrl } from '@/utils/authUiRuntime';

export default new Accounts({
  sdkUrl: sdkApiUrl,
  token: () => useAuthStore().reactiveToken as string,
});
